'use strict';

const { fetchProductTileBanner } = require('./adformBidsRequest');

module.exports = {
    init: function () {
        document.addEventListener('DOMContentLoaded', () => {
            const tagMap = {};
            document.querySelectorAll('.js-adform-productTile-wrapper').forEach(wrapper => {
                const tagId = wrapper.getAttribute('data-tag-id');
                if (!tagId) {
                    return;
                }
                if (!tagMap[tagId]) {
                    tagMap[tagId] = {
                        id: tagId,
                        wrappers: []
                    };
                }

                tagMap[tagId].wrappers.push(wrapper);
            });
            Object.values(tagMap).forEach(entry => {
                fetchProductTileBanner(entry.id, entry.wrappers);
            });
        }, { once: true }); // context: cookiebot may fire event again when partially accepted (since cookiebot not 1st script in head)
    }
};
